import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { IncidentService } from 'src/app/services/api/incident.service';
import { CognitoService } from 'src/app/services/cognito.service';
import Swal from 'sweetalert2';
import { OpIncidentTableRow, OpIncidentTypes } from '../incidents.types';
import { DialogSelectServiceComponent } from '../operativas/dialog-select-service/dialog-select-service.component';
@Component({
  selector: 'app-dialog-update-op-incident',
  templateUrl: './dialog-update-op-incident.component.html',
  styleUrls: ['./dialog-update-op-incident.component.css']
})
export class DialogUpdateOpIncidentComponent implements OnInit {
  isUpdating: boolean = false;
  textError: string | null = null;
  opIncidentForm!: FormGroup;
  opIncidentTypes: OpIncidentTypes[] = [
    'Discrepancia en el itinerario pax / Biblia',
    'Falta de información y comunicación',
    'Errores en compra / reservas',
    'Tardanza u omisión de servicios',
    'Inconformidad de servicios',
    'Incidencia con aerolíneas',
    'Incidentes médicos',
    'Incidencias con trenes',
    'Robos o pérdidas',
    'Paros',
    'Otros'
  ];
  opIncidentStatus: string[] = ['CREATED', 'IN_PROGRESS', 'FINISHED'];

  selectedService: {
    serviceId: string;
    serviceName: string | null;
    serviceType: string | null;
    serviceProviderName: string | null;
  } | null = null;
  authUsername: string | null = null;

  constructor(
    private readonly incidentService: IncidentService,
    private readonly cognitoService: CognitoService,
    private fb: FormBuilder,

    public dialogRef: MatDialogRef<DialogUpdateOpIncidentComponent>,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public opIncidentTableRow: OpIncidentTableRow,
    public dialog: MatDialog
  ) {
    console.log({ originalIncident: opIncidentTableRow });
  }

  ngOnInit(): void {
    this.loadUser();

    const { opIncidentTableRow } = this;
    let initialSolutionTimeData: number | undefined = undefined;
    let initialSolutionTimeUnitData = 'Hora(s)';

    if (opIncidentTableRow.solutionTime) {
      const parts = opIncidentTableRow.solutionTime.split(' ');
      if (parts.length > 1) {
        initialSolutionTimeData = Number(parts[0]);
        initialSolutionTimeUnitData = parts.slice(1).join(' ');
      } else {
        initialSolutionTimeData = Number(opIncidentTableRow.solutionTime);
      }
    }

    let initialSolutionDateData = undefined;
    if (opIncidentTableRow.solutionDate) {
      initialSolutionDateData = opIncidentTableRow.solutionDate.split('T')[0];
    }

    this.opIncidentForm = this.fb.group({
      serviceId: [
        opIncidentTableRow.serviceId || undefined,
        Validators.nullValidator
      ],
      opIncidentType: [
        opIncidentTableRow.opIncidentType || '',
        Validators.required
      ],
      incidentStatus: [
        opIncidentTableRow.incidentStatus || '',
        [
          Validators.required,
          Validators.pattern(/^(CREATED|IN_PROGRESS|FINISHED)$/)
        ]
      ],
      description: [opIncidentTableRow.description || '', Validators.required],
      solutionDate: [initialSolutionDateData, Validators.nullValidator],
      solutionTime: [
        initialSolutionTimeData,
        [Validators.nullValidator, Validators.min(0)]
      ],
      solutionTimeUnit: [initialSolutionTimeUnitData],
      actions: [opIncidentTableRow.actions || undefined]
    });

    if (opIncidentTableRow.serviceId) {
      this.selectedService = {
        serviceId: opIncidentTableRow.serviceId,
        serviceName: opIncidentTableRow.serviceName,
        serviceType: opIncidentTableRow.serviceType,
        serviceProviderName: null
      };

      this.opIncidentForm.patchValue({
        serviceId: opIncidentTableRow.serviceId
      });
    }
  }

  loadUser() {
    return this.cognitoService
      .getUsername()
      .then((username) => {
        console.log({ username });
        this.authUsername = username;
        return username;
      })
      .catch((err) => {
        console.error('Error fetching username:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar usuario, por favor vuelva a iniciar sesión.'
        });
        throw err;
      });
  }

  updateOpIncident() {
    const { opIncidentTableRow } = this;
    if (!opIncidentTableRow.itineraryId) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title:
          'Error, el incidente debe estar asociado a un Itinerario, vuelva a intentar, de ser necesario, vuelve a iniciar sesión.',
        showConfirmButton: true
      });
      return;
    }
    if (this.opIncidentForm.invalid) {
      this.opIncidentForm.markAllAsTouched();
      return;
    }

    if (this.opIncidentForm.valid) {
      this.isUpdating = true;

      const formValue = this.opIncidentForm.value;

      console.log({ formValue });
      const payload = {
        incidentId: opIncidentTableRow.id,
        itineraryId: opIncidentTableRow.itineraryId,
        serviceId: formValue.serviceId ? formValue.serviceId : null,
        modifiedBy: this.authUsername!,

        opIncidentType: formValue.opIncidentType,
        incidentStatus: formValue.incidentStatus,
        description: formValue.description,

        solutionDate: formValue.solutionDate
          ? new Date(`${formValue.solutionDate}T00:00:00-05:00`).toISOString()
          : undefined,
        solutionTime: formValue.solutionTime
          ? `${formValue.solutionTime} ${formValue.solutionTimeUnit}`
          : undefined,
        actions: formValue.actions || undefined
      };

      this.incidentService
        .updateOpIncident(payload)
        .pipe(
          finalize(() => {
            this.isUpdating = false;
            console.log('updateOpIncident request completed');
          })
        )
        .subscribe({
          next: ({ updateOpIncident }) => {
            console.log('Incidencia actualizada con éxito:', updateOpIncident);

            this.dialogRef.close({
              event: 'op_incident_update',
              op_incident_update: {
                ...payload,
                serviceName: this.selectedService?.serviceName || null,
                serviceType: this.selectedService?.serviceType || null,
                serviceProviderName:
                  this.selectedService?.serviceProviderName || null
              }
            });
          },
          error: (error) => {
            console.error('Error al actualizar la incidencia:', error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Error al actualizar la incidencia',
              showConfirmButton: true
            });
          }
        });
    } else {
      // Si el formulario no es válido, marca todos los controles como tocados
      this.opIncidentForm.markAllAsTouched();
      console.warn(
        'El formulario no es válido. Por favor completa todos los campos requeridos.'
      );
    }
  }

  openDialogListServices() {
    const dialogConfig = new MatDialogConfig();
    console.log({ availableServices: this.opIncidentTableRow });

    dialogConfig.data = {
      itineraryId: this.opIncidentTableRow.itineraryId,
      availableServices: undefined,
      associatedServiceIds: undefined,
      activityDayNumber: undefined,
      activityDayName: undefined
    };

    dialogConfig.width = '80%';
    dialogConfig.maxHeight = '750px';
    dialogConfig.maxWidth = '700px';

    const dialogRef = this.dialog.open(
      DialogSelectServiceComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((result) => {
      console.log({ dialogResult: result });

      if (!result || result.event === 'nothing') return;
      if (!result.op_incident_append_service.serviceId || !this.authUsername) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title:
            'Parece que el servicio seleccionado no cargó correctamente, por favor vuelva a intentar. Si el error persiste, vuelva a iniciar sesión.'
        });
        return;
      }
      this.selectedService = {
        serviceId: result.op_incident_append_service.serviceId,
        serviceName: result.op_incident_append_service.serviceName,
        serviceType: result.op_incident_append_service.serviceType,
        serviceProviderName:
          result.op_incident_append_service.serviceProviderName
      };

      this.opIncidentForm.patchValue({
        serviceId: result.op_incident_append_service.serviceId
      });

      console.log({ opIncidentForm: this.opIncidentForm });
    });
  }

  removeService() {
    this.selectedService = null;
    this.opIncidentForm.patchValue({
      serviceId: null
    });
  }
  renameOpIncidentStatus(status: string) {
    switch (status) {
      case 'CREATED':
        return 'Creado';
      case 'IN_PROGRESS':
        return 'En Proceso';
      case 'FINISHED':
        return 'Solucionado';
      default:
        return status;
    }
  }
  close(): void {
    this.dialogRef.close({ event: 'nothing' });
  }
}
